import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AppProviders } from './app/providers'
import { AppRouter } from './app/router'
import './shared/i18n/config'
import './styles/globals.css'
import './design-system/theme.css'

// Import mock authentication for development
import '@/features/xroad/utils/mockAuth'

document.documentElement.setAttribute('data-theme', 'glass-royal-blue')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </BrowserRouter>
  </React.StrictMode>
)
